import React, { Suspense, lazy, useRef, useCallback } from "react";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useActiveMeasurementSession } from "../recording/session/ActiveMeasurementSessionContext";

const RecordingSpirometry = lazy(() => import("recordingSpirometry/App"));

export default function RecordingSpirometryRouter(props) {
  const navigate = useNavigate();
  const didRedirectRef = useRef(false);
  const { active } = useActiveMeasurementSession();

  const handleUploadStatus = useCallback(
    (nextStatus) => {
      props.onUploadStatus?.(nextStatus);

      if (nextStatus === "uploading" && !didRedirectRef.current) {
        didRedirectRef.current = true;
        navigate("/recording/spirometry", { replace: true });
      }
    },
    [navigate, props],
  );

  const sessionKey = active?.id ?? "no-session";

  return (
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingSpirometry
        key={sessionKey}
        sessionId={active?.id ?? null}
        sessionMode={active?.mode ?? null}
        {...props}
        onUploadStatus={handleUploadStatus}
        onUploadProgress={props.onUploadProgress}
      />
    </Suspense>
  );
}
